export default {
  category_name: 'Osta lahjakortti',
};
